import React from "react";
import Header from "./Header";
import EntityView from "../entities/EntityView";

export default function LayoutEntityView() {
  return (
    <>
      <Header />
      <EntityView />
    </>
  );
}
